module.exports = __webpack_public_path__ + "img/yl.9fbe2287.svg";